import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
// import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
// import { library } from '@fortawesome/fontawesome-svg-core';
// import {
//   faGithub,
//   faInstagram, faMediumM,
//   faTwitter,
//   faYoutube
// } from '@fortawesome/free-brands-svg-icons';
// import {
//   faBars,
//   faBook, faCaretDown, faCaretUp,
//   faCheck, faCog,
//   faEdit,
//   faExclamationTriangle,
//   faFilter,
//   faLanguage,
//   faLightbulb, faPaintBrush, faPlayCircle,
//   faPlus, faPowerOff,
//   faRocket,
//   faSquare,
//   faStream, faTasks, faTimes, faTrash, faUserCircle,
//   faWindowMaximize
// } from '@fortawesome/free-solid-svg-icons';

import { AddDialogBoxComponent } from './components/add-dialog-box/add-dialog-box.component';
import { AlertDialogComponent } from './components/alert-dialog/alert-dialog.component';
import { CoreModule } from '../registered-user/core/core.module';
import { DualListComponent } from './components/dual-list/dual-list.component';
import { MaterialModule } from './material.module';
import { AuthGuardService } from './services/auth-guard.service';
import { LoaderService } from './services/loader.service';
import { UserDataService } from './services/userData.service';
import { SearchQueryBuilderComponent } from './components/search-query-builder/search-query-builder.component';
import { LoaderComponent } from './components/loader/loader.component';
import { LoaderInterceptor } from '../registered-user/core/http-interceptors/loader-interceptor.service';
import { ShowAuthedDirective } from './directives/show-authed.directive';
import { PhoneNumberOnlyDirective } from './directives/phone-number-only.directive';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
//import { MatTableExporterModule } from 'mat-table-exporter';
import { TokenInterceptor } from '@app/registered-user/core/http-interceptors/http-token.interceptor';
import { AccountUpdateDialogComponent } from './components/account-update-dialog/account-update-dialog.component';
import { NgxMaterialIntlTelInputComponent } from 'ngx-material-intl-tel-input';


// library.add(
//   faBars,
//   faUserCircle,
//   faPowerOff,
//   faCog,
//   faRocket,
//   faPlayCircle,
//   faGithub,
//   faMediumM,
//   faTwitter,
//   faInstagram,
//   faYoutube,
//   faPlus,
//   faEdit,
//   faTrash,
//   faTimes,
//   faCaretUp,
//   faCaretDown,
//   faExclamationTriangle,
//   faFilter,
//   faTasks,
//   faCheck,
//   faSquare,
//   faLanguage,
//   faPaintBrush,
//   faLightbulb,
//   faWindowMaximize,
//   faStream,
//   faBook
// );

@NgModule({
  declarations: [
    AlertDialogComponent,
    ShowAuthedDirective,
    SearchQueryBuilderComponent,
    DualListComponent,
    LoaderComponent,
    AddDialogBoxComponent,
    AccountUpdateDialogComponent
  ],
  imports: [
    MaterialModule,
    RouterModule,
    CommonModule,
    CoreModule,
    // FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
   // MatTableExporterModule,
    NgMultiSelectDropDownModule,
    NgxMaterialIntlTelInputComponent,
    PhoneNumberOnlyDirective
  ],
  exports: [
    MaterialModule,
    PhoneNumberOnlyDirective,
    // FontAwesomeModule,
    ReactiveFormsModule,
    FormsModule,
    SearchQueryBuilderComponent,
    DualListComponent,
    LoaderComponent,
    AddDialogBoxComponent,
    NgxMaterialIntlTelInputComponent
  ],
  providers: [
    LoaderService, UserDataService, AuthGuardService,
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true }
  ],
})
export class SharedModule { }
